module.exports = __webpack_public_path__ + "static/media/luggage-cart.a64338e9.svg";